<!--
 * @Description: 
 * @FilePath: \haiwai_zb_pc\src\components\Home\JoinSelect.vue
 * @Version: 1.0
 * @Autor: CuiGang
 * @Date: 2021-01-21 15:53:07
 * @LastEditors: CuiGang
 * @LastEditTime: 2021-02-04 14:13:21
-->
<template>
  <div>
     
    <div
      class="join_selcet"
      v-if="taskList && taskList.length && taskList.length > 0"
    >
    

  <div class="tags">
    <div class="w">
      <el-tabs v-model="activeLangueIndex" @tab-click="selectLangueClick(activeLangueIndex)">
        <el-tab-pane
          v-for="(tag, index) in tags"
          :key="index"
          :label="tag"
          :name="index.toString()"
          :class="{ active: index === activeLangueIndex }"
        >
          <!-- 类型切换按钮组 -->
          <el-radio-group v-model="tabType" size="small">
            <el-radio-button :label="1">{{ $t("fy.novel") }}</el-radio-button>
            <el-radio-button :label="2">{{ $t("fy.playlet") }}</el-radio-button>
          </el-radio-group>

          <!-- 图书展示区 -->
          <div class="tag_book">
            <div class="w clearfix df">
              <template v-if="filterTasks.length">
                <div
                  v-for="(book, index) in filterTasks"
                  :key="index"
                  class="tag_book_item"
                  @click="openTestPrev(book)"
                >
                  <div class="inner">
                    <img :src="book.bookImg" alt="" />

                    <!-- 古言/现言标签，仅中文显示 -->
                    <el-tag v-if="book.targetLanguage === 'CHINESE'" size="mini" :type="book.ancientLanguage === 1 ? 'warning' : ''">
                      {{ book.ancientLanguage === 1 ? '古言' : '现言' }}
                    </el-tag>

                    <div class="book_name slh">{{ book.bookName }}</div>

                    <div class="time slh">{{ $t("deadline") }}:</div>
                    <div class="time slh">{{ book.endTime || "" }}</div>

                    <!-- 操作按钮 -->
                    <div class="actions">
                      <div class="btn" v-if="[0, 2].includes(book.type)">
                        {{ $t("home.translation") }}
                      </div>
                      <div class="sh btn" v-else-if="[1, 3].includes(book.type)">
                        {{ $t("home.check") }}
                      </div>

                      <div class="jz btn">
                        {{ $t("home.partTimeJob") }}
                      </div>

                      <!-- 作品类型按钮 -->
                      <div class="grey btn">
                        {{
                          [0, 1].includes(book.type)
                            ? $t("fy.novel")
                            : $t("fy.playlet")
                        }}
                      </div>
                    </div>

                    <!-- 源语言 -->
                    <div class="source-language">
                      <div class="language-content">
                        {{ $t("home.sourceLang") }}：{{ book.language }}
                      </div>
                      <img src="../../assets/dog-ear.png" alt="" />
                    </div>
                  </div>
                </div>
              </template>

              <!-- 无任务提示 -->
              <div class="no_task" v-else>
                <img src="../../assets/notasks.png" alt="" />
                <p>{{ $t("fy.noTasks") }}</p>
              </div>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>


     
      
    </div>
    
  </div>
</template>
<script>
export default {
  name: "join_selcet",
  data() {
    return {
      activeLangueIndex: "0",
      tag_booksItem: [],
      tags: [],
      tags: [
        // "英语",
        // "西班牙语",
        // "葡萄牙语",
        // "法语",
        // "德育",
        // "意大利语",
        // "鳄鱼",
        // "日语",
      ],
      tag_books: [
        // {
        //   bookname: "打井人1打井人1打井人1打井人1打井人1",
        //   endtime: "截止时间:2021-02-02",
        //   id: "123",
        // },
        // {
        //   bookname: "打井人2",
        //   endtime: "截止时间:2021-02-0打井人1打井人1打井人1打井人12",
        // },
        // {
        //   bookname: "打井人3",
        //   endtime: "截止时间:2021-02-02",
        // },
        // {
        //   bookname: "打井人3",
        //   endtime: "截止时间:2021-02-02",
        // },
      ],
      langMap: {
        ENGLISH: "英语",
        CHINESE: "中文",
        ENGLISH_TAGALOG: "英语(菲律宾本土语言)",
        SPANISH: "西班牙语",
        NEDERLANDS: "荷兰语",
        DEUTSCH: "德语",
        FRENCH: "法语",
        ITALIANO: "意大利语",
        ROMANIA: "罗马尼亚语",
        FILIPINO: "菲律宾语",
        BAHASA_INDONESIA: "印尼语",
        BAHASA_MELAYU: "马来语",
        VIETNAMESE: "越语",
        ARAB: "阿拉伯语",
        THAI: "泰语",
        KOREAN: "韩语",
        OTHER: "其他语言"
      },
      tabType: 1 //  1 小说 2 短剧
    };
  },
  props: {
    taskList: {
      type: Array,
      default: undefined
    }
  },
  computed: {
    filterTasks() {
      if (this.tabType === 1) {
        return this.tag_booksItem.filter(item=> [0,1].includes(item.type))
      } else if (this.tabType === 2) {
        return this.tag_booksItem.filter(item=> [2,3].includes(item.type))
      }
    }
  },
  watch: {
    taskList(val) {
      this.tag_books = val;
      this.tag_booksItem = this.tag_books[0]["testTaskVos"] || [];
      let tagsList = [];
      for (let i = 0; i < this.tag_books.length; i++) {
        tagsList.push(this.tag_books[i].targetLanguage);
      }
      this.tags = tagsList;
    }
  },
  methods: {
    openTestPrev(bookInfo) {
      if([0,2].includes(bookInfo.type)){
        this.$router.push(`/testprev/${bookInfo.id}`);
      } else if([1,3].includes(bookInfo.type)){
        this.$router.push(`/reviewprev/${bookInfo.id}`);
      }
    },
    selectLangueClick(index) {
      this.activeLangueIndex = index;
      this.tag_booksItem = this.taskList[index].testTaskVos;
    }
  }
};
</script>
<style lang="less">
.join_selcet {
  .df {
    display: flex;
    flex-wrap: wrap;
  }
  .tags {
    width: 100%;
    .w {
      .tag_item {
        padding: 0 4px;
        height: 49px;
        line-height: 49px;
        cursor: pointer;
        display: inline-block;
        font-size: 13px;
        font-family: PingFang-SC-Medium, PingFang-SC;
        font-weight: 500;
        color: #666666;
        margin-right: 40px;
        &:last-child {
          margin-right: 0;
        }
        &.active {
          font-size: 15px;
          color: rgba(16, 119, 255, 1);
          font-weight: bold;
          border-bottom: 2px solid rgba(16, 119, 255, 1);
        }
      }
    }
  }
  .tag_book {
    width: 100%;
    padding-top: 20px;
    min-height: 324px;
    .tag_book_item {
      cursor: pointer;
      width: 222px;
      box-sizing: border-box;
      padding: 23px 12px;
      margin-right: 27px;
      background: url(../../assets/book_bg.png) no-repeat center;
      background-size: 100% 100%;
      margin-bottom: 28px;
      &:nth-child(4n) {
        margin-right: 0;
      }
      .inner {
        width: 100%;
        height: 100%;
        padding: 11px;
        background: #fff;
        position: relative;

        img {
          width: 100%;
          height: 234px;
          margin-bottom: 8px;
          background: #f1f1f1;
          object-fit: cover;
        }

        .book_name {
          width: 100%;
          height: 21px;
          font-size: 15px;
          font-family: PingFang-SC-Heavy, PingFang-SC;
          font-weight: 800;
          color: #333333;
          line-height: 21px;
          margin-bottom: 4px;
        }

        .time {
          height: 17px;
          font-size: 11px;
          font-family: PingFang-SC-Medium, PingFang-SC;
          font-weight: 500;
          color: #333333;
          line-height: 17px;
          margin-bottom: 4px;
        }

        .actions {
          .btn {
            display: inline-block;
            // width: 47px;
            padding: 0 10px;
            height: 23px;
            line-height: 23px;
            background: #00c25f;
            color: #fff;
            text-align: center;
            margin-right: 8px;
            font-size: 13px;
            font-family: PingFang-SC-Medium, PingFang-SC;
            font-weight: 500;
          }
          .jz {
            margin-top: 4px;
            background: #ff8450;
          }
          .sh {
            background: #4260f7;
          }
          .grey {
            background: #868686;
          }
        }
        .source-language {
          position: absolute;
          top: 11px;
          left: -4px;
          display: flex;
          // max-width: 160px;
          flex-direction: column;
          .language-content {
            max-width: 200px;
            background: linear-gradient(225deg, #48abff 0%, #1077ff 100%);
            padding: 4px 8px;
            font-size: 12px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #ffffff;
            line-height: 18px;
          }
          img {
            width: 4px;
            height: 4px;
            min-height: 0;
            margin: 0;
            padding: 0;
            background-color: transparent;
          }
        }
      }
    }
  }
  .no_task {
    width: 214px;
    display: block;
    margin: 100px auto 0;
    p {
      text-align: center;
      font-size: 12px;
      color: #666666;
    }
  }
}
</style>
